<template>
    <BaseField v-bind="$props" v-on="$listeners">
        <Dropdown
            class="value-field"
            :uniqueId="`segmentConditionEnumField${id}`"
            :selectedId="value"
            :options="options"
            :defaultText="placeholder"
            :searchEnabled="false"
            @dropdownSelectedItemChanged="$emit('update:value', $event.id)"
            height="34"
        />
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';
import Dropdown from 'components/dropdowns/Dropdown.vue';

export default {
    name: 'EnumField',
    components: {
        BaseField,
        Dropdown
    },
    props: {
        ...BaseField.props,
        value: String,
        options: {
            type: Array,
            default: () => ([])
        },
        placeholder: String,
        id: Number
    }
};
</script>
